import { getToken } from '../../../logic/token'

export default {
  token: getToken(),
  id: undefined,
  name: '',
  is_mate: -1,
  company: '',
  avatarPath: '',
  unread: 0,
  notifications: [],
  subscription: null,
  contract_plan: 0,
  permission: null,
  enable_copyright_operation: true,
  invoice: {},
  enable_link_map: true,
}
